import React from "react";

import ChevronLeft from "@material-ui/icons/ChevronLeft";

import {
    Edit,
    TextInput,
    SelectInput,
    SimpleForm,
    required,
    TopToolbar,
    ListButton,
    ShowButton,
    useNotify,
    useRefresh,
    ReferenceInput,
    NumberInput,
    AutocompleteInput,
    SaveButton,
    Toolbar
} from "react-admin";

import { GenericTable } from "../__common/GenericTable";
import { PhagesHostsFields } from "./PhagesHostsFields";
import { PhagesHostsExternalFields } from "./PhagesHostsExternalFields";

const PhagesActions = ({ basePath, data }) => (
    <TopToolbar>
        <ListButton basePath={basePath} label="Back" icon={<ChevronLeft />} />
        <ShowButton basePath={basePath} record={data} />
    </TopToolbar>
);

const PhageEditToolbar = (props) => {
    return (
        <Toolbar {...props}>
            <SaveButton
                label="Save"
                submitOnEnter={false}
            />
            <span>&nbsp;</span>
        </Toolbar>
    );
};

export const PhagesEdit = (props) => {
    const notify = useNotify();
    const refresh = useRefresh();
    // const redirect = useRedirect();

    const onSuccess = () => {
        notify(`Changes saved`);
        // redirect("/posts");
        refresh();
    };

    return (
        <Edit
            title="Edit Phage."
            undoable={false}
            onSuccess={onSuccess}
            submitOnEnter={true}
            actions={<PhagesActions />}
            {...props}
        >
            <SimpleForm toolbar={<PhageEditToolbar></PhageEditToolbar>}>
                <TextInput source="code" validate={required()} />
                <NumberInput label="Generation" source="generation" /* validate={required()} */ /* onChange={value => updateAuxGeneration(value)} */ />

                <ReferenceInput
                    label="Sample"
                    source="id_sample"
                    reference="samples"
                    //validate={required()}
                >
                    <AutocompleteInput
                        resettable={true}
                        clearAlwaysVisible={true}
                        optionText="code"
                        shouldRenderSuggestions={(value) => value.trim().length > 1}
                        suggestionLimit={10}
                    />
                </ReferenceInput>



                <ReferenceInput
                    label="Bacteria of isolation"
                    source="id_bacteria_of_isolation"
                    reference="isolates"
                >
                    <AutocompleteInput
                        resettable={true}
                        clearAlwaysVisible={true}
                        optionText="code"
                        shouldRenderSuggestions={(value) => value.trim().length > 1}
                        suggestionLimit={10}
                    />
                </ReferenceInput>

                <TextInput label="Phage method" source="phage_method" />
                <TextInput label="Storage description" source="storage_description" />
                <TextInput
                    label="Strain of propagation"
                    source="strain_of_propagation"
                />
                <NumberInput label="Amount propagations" source="amount_propagations" />
                <TextInput label="Aproximate PFUs" source="aproximate_pfus" />

                <TextInput label="Notes." source="notes" multiline minRows={6} />

                {/* Storage */}
                <div className="title-subsection">STORAGE</div>

                <ReferenceInput
                    perPage={999999} // FIXME: This is a hack to avoid the "perPage" error
                    label="Storage"
                    source="phages_storages[0].id_storage"
                    reference="storages"
                >
                    <SelectInput optionText="storage" />
                </ReferenceInput>
                <TextInput source="phages_storages[0].tube_name" label="Tube name" />
                <NumberInput
                    source="phages_storages[0].tube_size"
                    label="Tube size (ml)"
                />
                <TextInput
                    source="phages_storages[0].notes"
                    label="Notes"
                    multiline
                    minRows={6}
                />
                {/* Host Range */}
                <div className="">HOST RANGE</div>
                {
                    <GenericTable
                        collectionName="phages_hosts"
                        body={{
                            id_isolate: undefined,
                            concentration: undefined,
                            quantification: undefined,
                            kills: undefined,
                            intensity: undefined,
                            susceptibility: undefined,
                            notes: undefined
                        }}
                        headers={["Isolates", "Concentration", "Quantificaction", "Kills?", "Intensity", "Susceptibility", "Notes"]}
                        genericTableRow={PhagesHostsFields}
                    >
                    </GenericTable>
                }
                <br></br>
                {/* External Host Range */}
                <div className="">EXTERNAL HOST RANGE</div>
                {
                    <GenericTable
                        collectionName="phages_hosts"
                        body={{
                            id_external_isolate: undefined,
                            is_external_isolate: true,
                            concentration: undefined,
                            quantification: undefined,
                            kills: undefined,
                            intensity: undefined,
                            susceptibility: undefined,
                            notes: undefined
                        }}
                        headers={["External Isolates", "Concentration", "Quantificaction", "Kills?", "Intensity", "Susceptibility", "Notes"]}
                        genericTableRow={PhagesHostsExternalFields}
                    >
                    </GenericTable>
                }
            </SimpleForm>
        </Edit>
    );
};
